import { fragments as artOrderStatusFragments } from "../../application/apps/ArtApp/components/ArtOrderStatus/graph";
import { gql } from "@apollo/client";

const markOrderAsNoLongerOnArtworkHoldMutation = gql`
  mutation($orderId: ID!) {
    markOrderAsNoLongerOnArtworkHold(orderId: $orderId) {
      errors {
        orderId
      }
      updatedOrder {
        ...ArtOrderStatus_order
      }
      succeeded
    }
  }
  ${artOrderStatusFragments.order}
`;

export default markOrderAsNoLongerOnArtworkHoldMutation;
